import React from 'react';
import styles from './button.module.css';

const Button = props => {
  return (
    <button className={styles.button} data-cancel={props.datacancel} data-attr={props.dataAttr} type={props.type} onClick={props.onClick} id={props.id} disabled={props.disabled}>
      <span>{props.title}</span>
    </button>
  )
}

export default Button;